import { render } from "./UnitTypeList.vue?vue&type=template&id=9c570734&scoped=true"
import script from "./UnitTypeList.vue?vue&type=script&lang=js"
export * from "./UnitTypeList.vue?vue&type=script&lang=js"

import "./UnitTypeList.vue?vue&type=style&index=0&id=9c570734&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c570734"]])

export default __exports__